import { withForm } from '@components/ui/form/form';
import { challengeFormOptions } from '../challenge-form-options';

/**
 * First step of challenge creation form
 * Collects challenge name and description
 */
export const ChallengeDetailsStep = withForm({
  ...challengeFormOptions,
  render: function Render({ form }) {
    return (
      <div className="space-y-6">
        <form.AppForm>
          <form.AppField name="name">
            {(field) => (
              <field.TextField
                label="Challenge Name"
                placeholder="e.g., Advanced Sensor Technologies"
                required
              />
            )}
          </form.AppField>
          <form.AppField name="description">
            {(field) => (
              <field.TextAreaField
                label="Description"
                placeholder="Describe the purpose of this challenge..."
                rows={4}
              />
            )}
          </form.AppField>
        </form.AppForm>
      </div>
    );
  },
});
